import { useState, useRef, useEffect } from "react";
import { Player } from "../utils/player";
import { Recorder } from "../utils/recorder";
import BotProfile from "../assets/bot-profile.png"
import TopNavBar from "../components/TopNavBar";
import UnifiedVoiceComponent from "../components/UnifiedVoiceComponent";
import ChatComponent from "../components/ChatComponent";
import micOffIcon from "../assets/mic-off.svg";
import micOnIcon from "../assets/mic-on.svg";
// import callIcon from "../assets/call.svg";
import callDropIcon from "../assets/call-end.svg";
import callIcon from "../assets/call.svg";
import { useNavigate } from "react-router-dom";

let audioRecorder: Recorder;
let audioPlayer: Player;
let socket: WebSocket | null = null;

let recordingActive = false;
let buffer: Uint8Array = new Uint8Array();
let isSessionConfigured = false; // Track session state

const WebSocketPage = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [isMicOn, setIsMicOn] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [selectedVoice, setSelectedVoice] = useState("Merrisa")
  const [selectedPrompt, setSelectedPrompt] = useState("HRA");
  const [isTranscriptionOn, setIsTranscriptionOn] = useState(true);
  const [messages, setMessages] = useState<{ text: string, sender: "user" | "bot" }[]>([]);
  const [streamingMessage, setStreamingMessage] = useState<{ text: string; sender: "user" | "bot" } | null>(null);
  const [isSpeechStarted, setIsSpeechStarted] = useState(false);

  const [isShowDownloadButton, setShowDownloadButton] = useState(false);

  // const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isMetadataLoading,  setIsMetadataLoading] = useState(false);
  const [error, setError] = useState(null);

  const isFirstUserMessageRef = useRef(true);
  


  // const [isAudioPlaying, setIsAudioPlaying] = useState(false);


  const navigate = useNavigate();
  const promptvalue = "hra";  // Hardcoded to "hra" instead of using the dropdown logic




  const handleMicToggle = () => {
    setIsMicOn((prev) => {
      const newMicState = !prev;
      
      if (newMicState) {
        // Unmute: Resume audio recording
        if (audioRecorder) {
          recordingActive = true;
        }
      } else {
        // Mute: Pause audio recording
        if (audioRecorder) {
          recordingActive = false;
          // Clear the buffer when muting to prevent sending old audio data when unmuting
          buffer = new Uint8Array();
        }
      }
      
      return newMicState;
    });
  };
  

  const handlePlayToggle = () => {
    setIsPlaying(!isPlaying);
    // console.log("Playback state:", !isPlaying ? "Playing" : "Stopped");
    if (!isPlaying) {
      startRealTime();
      setShowDownloadButton(true);
    } else {
      disconnectWebSocket();
    }
  };



  const handleMetadataDownload = async () => {
    const id = sessionStorage.getItem("clientId");
    

    // const apiEndPoint = `https://capp-wizr-autosolve-rtaudio-dev.agreeablemoss-24711855.eastus.azurecontainerapps.io/api/v1/metadata/conversation/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `http://localhost:8001/api/v1/conversation/${id}/download`;
    const apiEndPoint = `https://api.blmvoiceagent.com/api/v1/conversation/${id}/download`;


    // const apiEndPoint = `http://localhost:8001/api/v1/metadata/conversation/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `https://capp-bloom-voice-rtaudio-dev.whitebush-b267c238.northcentralus.azurecontainerapps.io/api/v1/metadata/conversation/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `https://capp-bloom-voice-rtaudio-demo.whitebush-b267c238.northcentralus.azurecontainerapps.io/api/v1/metadata/conversation/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    setIsMetadataLoading(true);
    setError(null);

    try {
        // Make a request to the API endpoint to download the file
        const response = await fetch(apiEndPoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Create a blob from the response
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);

        // Create an anchor element and trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `conversation-metadata-${id}.json`); // Set the file name
        const filename = selectedPrompt.toLowerCase() === 'hra' ? `hra-flow-conversation-metadata-${id}.json`:`aetna-flow-conversation-metadata-${id}.json`;
        link.setAttribute('download', filename); // Set the file name
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Clean up the object URL
        window.URL.revokeObjectURL(downloadUrl);
    } catch (err:any) {
        setError(err.message || "An unexpected error occurred.");
    } finally {
        setIsMetadataLoading(false);
    }
};

  
  

  const handleSummaryDownload = async () => {

    const id = sessionStorage.getItem("clientId");
    // GET http://localhost:8000/api/v1/conversation/<client_id>/download
    // const apiEndPoint = `http://localhost:8001/api/v1/conversation/${id}/download`;
    // const apiEndPoint = `http://localhost:8000/api/v1/conversation/${id}/download`;
    // const apiEndPoint = `http://localhost:8000/api/v1/conversation/${id}/download`;
    // const apiEndPoint = `https://api.bloomvoice.com/api/v1/conversation/${id}/download`;
    const apiEndPoint = `http://localhost:8001/api/v1/hra/${id}/extract`;



    // const apiEndPoint = `https://capp-wizr-autosolve-rtaudio-dev.agreeablemoss-24711855.eastus.azurecontainerapps.io/api/v1/metadata/hra/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `http://localhost:8001/api/v1/metadata/hra/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `https://capp-bloom-voice-rtaudio-dev.whitebush-b267c238.northcentralus.azurecontainerapps.io/api/v1/metadata/hra/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    // const apiEndPoint = `https://capp-bloom-voice-rtaudio-demo.whitebush-b267c238.northcentralus.azurecontainerapps.io/api/v1/metadata/hra/${id}?prompt_flow=${encodeURIComponent(promptvalue)}`;
    setIsLoading(true);
    setError(null);
  
    try {

      const resposne = await fetch(apiEndPoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if(!resposne.ok) {
        throw new Error(`HTTP error! Status: ${resposne.status}`);
      }
      const blob = await resposne.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      const filename = selectedPrompt.toLowerCase() === 'hra' ? `hra-flow-assessment-${id}.json`:`aetna-flow-assessment-${id}.json`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
    
    } catch (err:any) {
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setIsLoading(false);
    }

  }

  
  const sessioUpdateEvent = {
    type: "session.update",
    session: {
      turn_detection: {
        type: "server_vad",
      },
      input_audio_transcription: {
        model: "whisper-1",
      },
      language: selectedLanguage,
      persona: selectedVoice.toLowerCase(),
      botId: selectedVoice.toLowerCase() === "Merrisa" ? "0001" : "00012",
      prompt: promptvalue,
      healthplan_name: localStorage.getItem("healthplan_name") || "Aetna",
      firstName: localStorage.getItem("first_name") || "Robert",
      lastName: localStorage.getItem("last_name") || "John",
      dob: localStorage.getItem("date_of_birth") || "07/01/1958",
      benefit_plan: localStorage.getItem("benefit_plan") || "hmopos",
      doctorName: localStorage.getItem("doctor_name") || "Dr. Williamson"
    },
  };

  const disconnectEvent = {
    type: "session.disconnect",
  }


  // WebSocket connection handler
  const connectWebSocket = () => {
    const clientId = crypto.randomUUID();
    setIsConnecting(true); // Set connecting state to true
    
    // socket = new WebSocket(`ws://localhost:8001/ws/${clientId}`);
    socket = new WebSocket(`wss://api.blmvoiceagent.com/ws/${clientId}`);
    
    sessionStorage.setItem("clientId", clientId);

    socket.onopen = () => {
      console.log("WebSocket connection opened");
      setIsConnected(true);
      setIsConnecting(false); // Connection complete
      console.log({ isConnected });

      sendMessage();
    };

    socket.onmessage = (event) => {
      // console.log("Message received:", event.data);
      const message = JSON.parse(event.data);
      handleWebSocketMessage(message); // Handle the incoming WebSocket message
    };
    ;
    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      setIsConnecting(false); // Connection failed
    };

    socket.onclose = () => {
      // console.log("WebSocket connection closed");
      setIsConnected(false);
      setIsConnecting(false); // Connection closed
      socket = null;
    };
  };

  // Handle incoming WebSocket messages
  const handleWebSocketMessage = async (message: any) => {
    if (message.type === "session.created") {
      // console.log("Session created successfully");
      isSessionConfigured = true; // Mark session as configured
      
      // Process WAV file before starting microphone recording
      await processWavFileFromUrl("https://bottest.blob.core.windows.net/audio-test/hello.wav");
      
      // Start audio recording after processing the WAV file
      startAudioRecording();
    }

    if (message.type === "conversation.item.input_audio_transcription.completed") {
      // console.log("inside conversation.item.input_audio_transcription.completed", message);

      if (isFirstUserMessageRef.current) {
        isFirstUserMessageRef.current = false; // Set the ref to false after the first message
        return; // Skip the first message
      }

      const userMessage: { text: string; sender: "user" } = {
        sender: "user",
        text: message?.transcript || "Unable to translate the response"
      };

      setMessages((prevMessages) => [...prevMessages, userMessage]);
    }

    if (message.type === "response.audio_transcript.delta") {
      const deltaToParse = message?.data?.delta || message?.delta || "";
      
      // If the last message in the array is from the bot, append to it instead of using streamingMessage
      setMessages(prevMessages => {
        const lastMessage = prevMessages[prevMessages.length - 1];
        
        // If there's an existing bot message, append to it with proper spacing
        if (lastMessage && lastMessage.sender === "bot") {
          const updatedMessages = [...prevMessages];
          
          // Check if we need to add a space between chunks
          let formattedText = lastMessage.text;
          
          // Only add space if:
          // 1. Last message doesn't end with space, newline, or empty string
          // 2. New chunk doesn't start with space, period, comma, or other punctuation
          const lastChar = formattedText.slice(-1);
          const firstChar = deltaToParse.charAt(0);
          
          // Don't add space before punctuation or if there's already a space
          const punctuation = ['.', ',', '!', '?', ':', ';'];
          const needsSpace = lastChar && 
                            lastChar !== ' ' && 
                            lastChar !== '\n' && 
                            !punctuation.includes(firstChar) &&
                            firstChar !== ' ';
                            
          // Add space if needed
          if (needsSpace) {
            formattedText += ' ';
          }
          
          // Now append the new text
          formattedText += deltaToParse;
          
          updatedMessages[updatedMessages.length - 1] = {
            ...lastMessage,
            text: formattedText
          };
          return updatedMessages;
        } 
        // Otherwise create a new message
        else {
          return [...prevMessages, { sender: "bot", text: deltaToParse }];
        }
      });
      
      // Clear the streaming message since we're not using it
      setStreamingMessage(null);
    }

    if (message.type === "input_audio_buffer.speech_started") {
      // console.log("inside input_audio_buffer.speech_started", message);
      setIsSpeechStarted(true);
      audioPlayer.clear()

    }

    if (message.type === "input_audio_buffer.speech_stopped") {
      // console.log("inside input_audio_buffer.speech_stopped", message);
      setIsSpeechStarted(false);

    }

    if(message.type === "error" && message.data==="Cannot write to closing transport"){
      console.log("inside error page", message);
      navigate("/error");
      disconnectWebSocket();
      websocketSafeClose()
    }
    
    if (message.type === "response.audio.delta" && isSessionConfigured) {
      // console.log("Received audio data");
      try {
        const binary = atob(message.delta);
        const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
        const pcmData = new Int16Array(bytes.buffer);
        audioPlayer.play(pcmData);
      } catch (error) {
        // console.error("Error processing audio delta:", error);
      }
    }

    if(message.type === "disconnect"){
      console.log("inside disconnct", message);
      websocketSafeClose();
    }
  };

  const websocketSafeClose = () =>{
    if(socket){
      socket.close();
      setIsConnected(false);
      socket = null;
    }
  }

  // Send session update message to WebSocket
  const sendMessage = () => {
    // console.log("inside sendMessage", socket?.readyState);

    if (socket && socket.readyState === WebSocket.OPEN) {
      const message = JSON.stringify(sessioUpdateEvent);
      socket.send(message);
      console.log("Session update sent");
    } else {
      console.log("WebSocket is not open yet.");
    }
  };


  const processWavFileFromUrl = async (fileUrl: string) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
  
      const arrayBuffer = await response.arrayBuffer();
  
      // Skip WAV header (first 44 bytes)
      const wavData = arrayBuffer.slice(44);
      processAudioRecordingBuffer(wavData);
    } catch (error) {
      console.error("Error processing WAV file:", error);
    }
  };

  const startAudioRecording = async () => {
    try {
      // console.log("Starting audio recording...");
      if (audioRecorder) {
        audioRecorder.stop(); // Stop the previous recording if any
      }
      if (audioPlayer) {
        audioPlayer.clear(); // Clear the previous player if any
      }

      audioRecorder = new Recorder(processAudioRecordingBuffer);
      audioPlayer = new Player();
      await audioPlayer.init(16000); // <-- Change to 16000
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioRecorder.start(stream); // Start the audio recorder
      recordingActive = true;

    } catch (error) {
      console.error("Error initializing audio recording:", error);
    }
  };

  // Combine new audio data with the existing buffer
  const combineArray = (newData: Uint8Array) => {
    const newBuffer = new Uint8Array(buffer.length + newData.length);
    newBuffer.set(buffer);
    newBuffer.set(newData, buffer.length);
    buffer = newBuffer;
  };

  // Process and send audio buffer to WebSocket
  const processAudioRecordingBuffer = (data: ArrayBuffer) => {

    if (!isMicOn) return; 
    const uint8Array = new Uint8Array(data);
    combineArray(uint8Array);

    if (buffer.length >= 4800) {
      const toSend = new Uint8Array(buffer.slice(0, 4800));
      buffer = new Uint8Array(buffer.slice(4800));

      const regularArray = String.fromCharCode(...toSend);
      const base64 = btoa(regularArray);

      if (recordingActive && socket && socket.readyState === WebSocket.OPEN) {
        const message = JSON.stringify({
          type: "input_audio_buffer.append",
          audio: base64,
        });
        socket.send(message);
      }
    }
  };

  // Start WebSocket connection and audio recording
  const startRealTime = () => {
    connectWebSocket(); // Start WebSocket connection
  };

  // Disconnect WebSocket connection
  const disconnectWebSocket = () => {
    if (socket) {
      audioPlayer.clear()
      const message = JSON.stringify(disconnectEvent);
      socket.send(message);
      // socket.close();
    }
  };

  const onTranscriptionToggle = () => {
    setIsTranscriptionOn(!isTranscriptionOn);
  };

  return (
    <div className="bg-gray-50 h-screen flex flex-col">
      {/* Connection loading overlay */}
      {isConnecting && !isConnected && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              {selectedVoice === "Merrisa" ? "Merrisa" : selectedVoice} is getting ready...
            </h3>
            <p className="text-sm text-gray-500">
              Please wait while we establish a secure connection.
            </p>
          </div>
        </div>
      )}

      <div>
        <TopNavBar isCallActive={isPlaying} />
      </div>
  
      {/* Main container */}
      <div className="flex-grow flex flex-col mx-0 md:mx-2 lg:mx-2 overflow-y-auto md:my-2 my-0 ">
        <div className="flex flex-col md:flex-row border-0 md:border-2 border-gray-50 rounded-2xl md:bg-gray-50 bg-white h-full overflow-hidden ">
          {/* Voice component section */}
          <div
            className={`w-full ${
              isTranscriptionOn ? "md:w-1/3" : "md:w-full"
            } order-1 md:order-2 flex flex-col  p-0 md:p-0 md:pt-4 `}
          >
            <UnifiedVoiceComponent
              isMicOn={isMicOn}
              isPlaying={isPlaying}
              selectedLanguage={selectedLanguage}
              selectedVoice={selectedVoice}
              isTranscriptionOn={isTranscriptionOn}
              onMicToggle={handleMicToggle}
              onPlayToggle={handlePlayToggle}
              isSpeechStarted={isSpeechStarted}
              handleMetadataDownload={handleMetadataDownload}
              handleSummaryDownload={handleSummaryDownload}
              isShowDownloadButton={isShowDownloadButton}
              isLoading={isLoading}
              isMetadataLoading={isMetadataLoading}
              onLanguageChange={(language) => setSelectedLanguage(language)}
              onVoiceChange={(voice) => setSelectedVoice(voice)}
              onTranscriptionToggle={onTranscriptionToggle}
            />
          </div>
  
          {/* Transcription section */}
          {isTranscriptionOn && (
            <div className="md:w-2/3 order-2 md:order-1 flex flex-col border-t md:border-t-0 border-white md:bg-gray-50  bg-white p-0 md:p-0 overflow-hidden "> 
            {/* md:border-r      removed this to remove the line between the 2 components  this was in the above line*/}
              <ChatComponent 
                botProfileImage={BotProfile} 
                messages={messages}
                isTranscriptionOn={isTranscriptionOn}
                onTranscriptionToggle={onTranscriptionToggle}
                handleMetadataDownload={handleMetadataDownload}
                handleSummaryDownload={handleSummaryDownload}
                isLoading={isLoading}
                isMetadataLoading={isMetadataLoading}
                selectedPrompt={selectedPrompt}
                isPlaying={isPlaying}
                isShowDownloadButton={isShowDownloadButton}
                selectedVoice={selectedVoice}
              />
            </div>
          )}
        </div>
      </div>
  
      {/* Mobile Controls - Only show when transcription is ON */}
      {isTranscriptionOn && (
        <div className="fixed bottom-0 left-0 right-0 bg-white py-4 shadow-lg md:hidden">
          <div className="flex justify-center items-center space-x-4 px-4 ">
            <button
              onClick={handleMicToggle}
              className="flex items-center justify-center w-12 h-12 bg-blue-600 rounded-full"
            >
              <img
                src={isMicOn ? micOnIcon : micOffIcon}
                alt="Mic Toggle"
                className="w-6 h-6"
              />
            </button>
  
            <button
              onClick={handlePlayToggle}
              className={`flex items-center justify-center w-12 h-12 rounded-full ${
                isPlaying ? "bg-red-500" : "bg-green-500"
              }`}
            >
              <img
                src={isPlaying ? callDropIcon : callIcon}
                alt="Play/Stop Toggle"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
  
};

export default WebSocketPage;
